import styled from 'styled-components'
import { colors } from '../../lib/colors'

// interface CARD_PROPS {
//   isBack?: boolean
//   animDelay?:number
// }

export const GameBoardContainer = styled.div`
  width: 100%;
`
export const Placeholder = styled.div<{ zIndex?: number }>`
  position: relative;
  width: 55px;
  height: 80px;
  text-align: center;
  background: ${colors.primaryLight};
  border-radius: 8px;
  z-index: ${({ zIndex }) => zIndex};
`
export const PlaceholderWrapper = styled.div`
  display: flex;
  justify-content: center;
  div:first-child {
    margin-right: 10px;
  }
  &.dealer {
    margin-bottom: 10px;
    margin-top: 35px;
  }
  &.player {
    margin-bottom: 25px;
  }
`
export const RiverWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
`
